var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import "../ui.css";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixBadge = function (_a) {
    var text = _a.text, backgroundColor = _a.backgroundColor, fontColor = _a.fontColor, borderColor = _a.borderColor, className = _a.className;
    var uiTheme = useDataUiTheme();
    var style = __assign(__assign(__assign({}, (backgroundColor ? { backgroundColor: backgroundColor } : {})), (fontColor ? { color: fontColor } : {})), (borderColor ? { borderColor: borderColor } : {}));
    return React.createElement("span", { className: ["radix-badge", className].filter(Boolean).join(" "), style: style, "data-ui-theme": uiTheme }, text);
};
